<template>
  <div class="parent">
    <!-- <nav-bar></nav-bar> -->
    <DetailsNav></DetailsNav>
    <head-first-widget
      :name="baseData.name"
      :date="publishDate"
      :desc="baseData.description"
      :logo="logoUrl"
      :logoDesc="logoDesc"
      :itemList="numItems"
      :video="baseData.pVideoUrl"
    ></head-first-widget>
    <div class="divOffsetParent">
      <industry-advantage-widge
        :title="industryAdvantageTitle"
        :subTitle="industryAdvantageSubTitle"
        :items="industryAdvantageItems"
      ></industry-advantage-widge>
      <flow-widge
        :flowData="flowData"
        :baseHeight="baseHeight"
        :localItemIndex="localItemIndex"
        class="web_scroll"
      ></flow-widge>
      <project-advantage-widge
        :title="projectAdvantageTitle"
        :subTitle="projectAdvantageSubTitle"
        :items="projectAdvantageImgs"
      >
      </project-advantage-widge>
      <target-learner-widge
        :title="targetLearnerTitle"
        :subTitle="targetLearnerSubTitle"
        :items="targetLearnerItems"
      ></target-learner-widge>
      <function-widge
        :title="functionTitle"
        :subTitle="functionSubtitle"
        :bgUrl="functionBgUrl"
        :bg="functionBg"
        titleColor="#36DA9C"
      ></function-widge>
      <technology-widge
        :title="technologyTitle"
        :subTitle="technologySubTitle"
        :bgUrl="technologyBgUrl"
        :details="technologyDetails"
      ></technology-widge>
      <course-widge
        :datas="courseDatas"
        :title="courseTitle"
        :subTitle="courseSubTitle"
        :bg="courseBg"
        titleColor="#36DA9C"
        subTitleColor="rgba(255,255,255,1)"
      ></course-widge>
      <teacher-display-widge
        :title="teacherTitle"
        :subTitle="teacherSubtitle"
        :bg="teacherBg"
        :items="teacherDetails"
      ></teacher-display-widge>
      <bottom-widge></bottom-widge>
    </div>
  </div>
</template>
<script>
// import navBar from "./../../../components/navBar";
import DetailsNav from "./../../../components/detailsNav.vue";
import bottomWidge from "./../../../components/bottomWidge";
import headFirstWidget from "./components/headFirstWidget";
import industryAdvantageWidge from "./components/industryAdvantageWidge";
import flowWidge from "./components/flowWidget";
import projectAdvantageWidge from "./components/projectAdvantageWidge";
import targetLearnerWidge from "./components/targetLearnerWidge";
import functionWidge from "./components/functionWidge";
import technologyWidge from "./components/technologyWidge";
import courseWidge from "./components/courseWidge";
import teacherDisplayWidge from "./components/teacherDisplayWidge";
import { Content } from "../../../../gqlapi/ContentDetail.js";
import { pushArr, courseDataToArr } from "./../../../js/tools";
export default {
  components: {
    // navBar,
    DetailsNav,
    bottomWidge,
    headFirstWidget,
    industryAdvantageWidge,
    projectAdvantageWidge,
    targetLearnerWidge,
    functionWidge,
    technologyWidge,
    courseWidge,
    teacherDisplayWidge,
    flowWidge,
  },
  data() {
    return {
      baseData: {},
      logoUrl: "",
      logoDesc: "",
      numItems: [],
      publishDate: "",
      industryAdvantageTitle: "",
      industryAdvantageSubTitle: "",
      industryAdvantageItems: [],
      flowData: [],
      baseHeight: 1000,
      localItemIndex: 0,
      projectAdvantageTitle: "",
      projectAdvantageSubTitle: "",
      projectAdvantageImgs: [],
      targetLearnerTitle: "",
      targetLearnerSubTitle: "",
      targetLearnerItems: [],
      functionTitle: "",
      functionSubtitle: "",
      functionBgUrl: "",
      functionBg: "",
      technologyTitle: "",
      technologySubTitle: "",
      technologyBgUrl: "",
      technologyDetails: [],
      courseTitle: "",
      courseSubTitle: "",
      courseDatas: [],
      courseBg: "",
      teacherTitle: "",
      teacherSubtitle: "",
      teacherBg: "",
      teacherDetails: [],
      scrollClass: {
        pInit: "parent web_scroll",
        pChange: "parent web_scroll  p-change",
        cInit: "ul-init",
        cChange: "",
      },
      scrollFlag: {
        top: true,
        bottom: true,
      },
    };
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    Object.freeze(this.scrollFlag);
    Object.freeze(this.scrollClass);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollHeight = this.baseHeight;
      let eles = document.querySelector(".divOffsetParent").children;
      let length = eles.length;
      if (localHeight > scrollHeight) {
        this.localItemIndex = 0;
      }
      for (let i = 2; i < length; i++) {
        if (localHeight > eles[i].offsetTop + scrollHeight -10) {
          this.localItemIndex = i - 1;
        }
      }
    },
    getData() {
      this.$axios.post('/api',{
            operationName: "Content",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: Content
        })
        .then((res) => {
          this.baseData = res.data.data.pContent
          this.getHeadFirstWidgeData();
          this.getIndustryAdvantageWidgeData();
          this.getFlowData();
          this.getProjectAdvantageWidgeData();
          this.getTargetLearnerWidgeData();
          this.getFunctionData();
          this.getTechnologyData();
          this.getCourseWidgeData();
          this.getTeacherDisplayWidgeData();
        });
    },
    getTeacherDisplayWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[6];
      if (!data) {
        return;
      }
      this.teacherTitle = data.title;
      this.teacherSubtitle = data.subTitle;
      let tuWen = data.tuWen ? data.tuWen : {};
      this.teacherBg = tuWen.image ? tuWen.image.url : "";
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      let items = [];
      for (let item of lieBiao) {
        items.push({
          title: item.title,
          subTitle: item.subTitle,
          url: item.image ? item.image.url : "",
          desc: item.description,
        });
      }
      this.teacherDetails = items;
    },
    getCourseWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[5];
      if (!data) {
        return;
      }
      this.courseTitle = data.title;
      this.courseSubTitle = data.subTitle;
      let tuWen = data.tuWen ? data.tuWen : {};
      this.courseBg = tuWen.textBgImage ? tuWen.textBgImage.url : "";
      let arr = [];
      courseDataToArr(
        baseData.courseOutlineTitle1,
        baseData.courseOutlineDesc1,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle2,
        baseData.courseOutlineDesc2,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle3,
        baseData.courseOutlineDesc3,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle4,
        baseData.courseOutlineDesc4,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle5,
        baseData.courseOutlineDesc5,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle6,
        baseData.courseOutlineDesc6,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle7,
        baseData.courseOutlineDesc7,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle8,
        baseData.courseOutlineDesc8,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle9,
        baseData.courseOutlineDesc9,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle10,
        baseData.courseOutlineDesc10,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle11,
        baseData.courseOutlineDesc11,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle12,
        baseData.courseOutlineDesc12,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle13,
        baseData.courseOutlineDesc13,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle14,
        baseData.courseOutlineDesc14,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle15,
        baseData.courseOutlineDesc15,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle16,
        baseData.courseOutlineDesc16,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle17,
        baseData.courseOutlineDesc17,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle18,
        baseData.courseOutlineDesc18,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle19,
        baseData.courseOutlineDesc19,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle20,
        baseData.courseOutlineDesc20,
        arr
      );
      this.courseDatas = arr;
    },
    getTechnologyData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[4];
      if (!data) {
        return;
      }
      this.technologyTitle = data.title;
      this.technologySubTitle = data.subTitle;
      let tuWen = data.tuWen ? data.tuWen : {};
      this.technologyBgUrl = tuWen.image.url;
      this.technologyDetails = tuWen.description ? tuWen.description.split("\n") :[];
    },
    getFunctionData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[3];
      if (!data) {
        return;
      }
      this.functionTitle = data.title;
      this.functionSubtitle = data.subTitle;
      let tuWen = data.tuWen ? data.tuWen : {};
      this.functionBgUrl = tuWen.image ? tuWen.image.url : "";
      this.functionBg = tuWen.bgImage ? tuWen.bgImage.url : "";
    },
    getTargetLearnerWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[2];
      if (!data) {
        return;
      }
      this.targetLearnerTitle = data.title;
      this.targetLearnerSubTitle = data.subTitle;
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      let items = [];
      for (let item of lieBiao) {
        items.push({
          title: item.title,
          desc: item.description,
          url: item.image.url,
        });
      }
      this.targetLearnerItems = items;
    },
    getFlowData() {
      let detailsList = this.baseData.detailsList;
      let arr = [];
      detailsList.forEach((item, index) => {
        arr.push({
          index: index,
          desc: item.navTitle,
        });
      });
      this.flowData = arr;
    },
    getIndustryAdvantageWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[0];
      if (!data) {
        return;
      }
      this.industryAdvantageTitle = data.title;
      this.industryAdvantageSubTitle = data.subTitle;
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      let items = [];
      for (let item of lieBiao) {
        items.push({
          title: item.title,
          desc: item.description,
          url: item.image.url,
        });
      }
      this.industryAdvantageItems = items;
      this.getBaseHeight();
    },
    getBaseHeight() {
      setTimeout(() => {
        this.baseHeight = document.querySelector(".divOffsetParent").offsetTop;
      });
    },
    getProjectAdvantageWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[1];
      if (!data) {
        return;
      }
      this.projectAdvantageTitle = data.title;
      this.projectAdvantageSubTitle = data.subTitle;
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      let imgs = [];
      for (let item of lieBiao) {
        if (item.image) {
          imgs.push(item.image.url);
        }
      }
      this.projectAdvantageImgs = imgs;
    },
    getHeadFirstWidgeData() {
      let baseData = this.baseData;
      this.logoUrl = baseData.trade
        ? baseData.trade.iconFile
          ? baseData.trade.iconFile.url
          : ""
        : "";
      this.logoDesc = baseData.trade ? baseData.trade.name : "";
      this.publishDate = baseData.lastUpdate;
      let numItems = [];
      pushArr(baseData.baseInfoTitle1, numItems);
      pushArr(baseData.baseInfoTitle2, numItems);
      pushArr(baseData.baseInfoTitle3, numItems);
      pushArr(baseData.baseInfoTitle4, numItems);
      pushArr(baseData.baseInfoTitle5, numItems);
      pushArr(baseData.baseInfoTitle6, numItems);
      this.numItems = numItems;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scss/index.scss";
</style>
